import { render, staticRenderFns } from "./cly-paginate.vue?vue&type=template&id=ec1330ba"
import script from "./cly-paginate.vue?vue&type=script&lang=js"
export * from "./cly-paginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports